import { SpendAreaDto, SpendAreaStatus } from '@sib/api';

export enum ProjectStatus {
  All = 'ALL',
  Mobilization = 'MOBILIZATION',
  SavingsEstimated = 'SAVINGS_ESTIMATED',
  Negotiations = 'NEGOTIATIONS',
  SavingsRealized = 'SAVINGS_REALIZED',
  MonitoringSavings = 'MONITORING_SAVINGS',
}

export interface SpendAreaListItem extends SpendAreaDto {
  isActive: boolean;
  adjustedStatus: SpendAreaStatus;
}

export interface UnnasignedSpendAreaListItem extends SpendAreaDto {}
